<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="cert">
        <img src="../../assets/img/certificado.png" >
        <div style="position: absolute;
    top: 150px;
    left: 210px;
    font-size: 18px;" >{{certificate.processNumber}}</div>
        <div style="position: absolute;
    top: 290px;
    left: 215px;
    font-size: 18px;" >{{certificate.person.name.trim()}}</div>
        <div style="  position: absolute;
    top: 325px;
    left: 235px;
    font-size: 18px;" >{{certificate.person.corporateName.trim()}}</div>
        <div style=" position: absolute;
    top: 365px;
    left: 115px;
    font-size: 18px;" >{{certificate.person.cnpj}}</div>
        <div style=" position: absolute;
    top: 395px;
    left: 180px;
    font-size: 18px;" >{{certificate.activity.name}}</div>
        <div style=" position: absolute;
    top: 420px;
    left: 180px;
    font-size: 18px;" >{{certificate.details}}</div>
       <div style=" position: absolute;
    top: 692px;
    left: 139px;
    font-size: 13px;" >{{formatarData(certificate.validity)}}</div>
       <div style=" position: absolute;
    top: 709px;
    left: 190px;
    font-size: 13px;" >{{formatarData(certificate.created)}}</div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "PrintCertificate",
  inject: ["loading"],
  data() {
    return {
      codigo: null,
      certificate: {},
      // accreditations: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.codigo = this.$route.params.id;

      this.$http
        .get(`/certificate/${this.$route.params.id}`)
        .then((response) => {
          this.certificate = response.data;
          console.log(this.certificate)
          this.$http.get("/accreditation/").then((response) => {
            // this.accreditations = response.data;
          });
        })
        .finally(() => {
          setTimeout(() => window.print(), 900);
        })
        .catch((error) => console.log(error));
    });
  },
  methods: {
    formatarData(data) {
      const date = new Date(data);
      var dia = date.getDate();
      if (dia < 10) {
        dia = "0" + dia;
      }

      var mes = date.getMonth() + 1;
      if (mes < 10) {
        mes = "0" + mes;
      }

      return `${dia}/${mes}/${date.getFullYear()}`;
    },
  },

};
</script>

<style scoped media="print">

@media screen {
  body *{
    display: none;
    visibility: hidden;
  }
}

@media print {
  @page {
    size: landscape;
    margin: 0mm; /* this affects the margin in the printer settings */
  }

  body * {
    visibility: hidden;
  }

  .container-fluid * {
    visibility: visible;
    margin: 0px;
  }
  .container-fluid {
    position: absolute;
    left: 0;
    top: 0;
  }

 
}

</style>


// WEBPACK FOOTER //
// src/components/pages/PrintCertificate.vue